(function(){
  'use strict';

  function initDpPdpAtc(){
    var form=document.querySelector('#dp-add-form.dp-u-form');
    if(!form||form.dataset.dpAjaxAtcReady==='1')return;

    var mainButton=form.querySelector('[data-dp-main-atc]');
    if(!mainButton)return;

    form.dataset.dpAjaxAtcReady='1';

    var stickyButton=document.querySelector('[data-dp-sticky-add]');
    var originalMain=(mainButton.textContent||'').trim()||'Add to Cart';
    var originalSticky=stickyButton?((stickyButton.textContent||'').trim()||'Add to Cart'):originalMain;
    var busy=false;
    var resetTimer=0;

    function jsonRoute(url,fallback){
      var value=url||fallback;
      if(/\.js$/.test(value))return value;
      return value.replace(/\/$/,'')+'.js';
    }

    function setStatus(text){
      mainButton.textContent=text;
      mainButton.setAttribute('aria-busy','true');
      if(stickyButton){
        stickyButton.textContent=text;
        stickyButton.setAttribute('aria-busy','true');
      }
    }

    function restoreButtons(){
      var soldOut=(window.languages&&window.languages.productFormSoldOut)||'Sold out';
      mainButton.textContent=mainButton.disabled?soldOut:originalMain;
      mainButton.removeAttribute('aria-busy');
      if(stickyButton){
        stickyButton.textContent=stickyButton.disabled?soldOut:originalSticky;
        stickyButton.removeAttribute('aria-busy');
      }
      busy=false;
    }

    function finishWith(text,delay){
      setStatus(text);
      window.clearTimeout(resetTimer);
      resetTimer=window.setTimeout(restoreButtons,delay);
    }

    function updateCartCount(){
      var cartUrl=jsonRoute(window.routes&&window.routes.cartUrl,'/cart');
      return fetch(cartUrl,{credentials:'same-origin',headers:{Accept:'application/json'}})
        .then(function(response){if(!response.ok)throw new Error('Cart refresh failed');return response.json();})
        .then(function(cart){
          document.querySelectorAll('.header__cart-count').forEach(function(el){el.textContent=cart.item_count;});
          if(window.theme)window.theme.cartCount=cart.item_count;
        })
        .catch(function(){/* The theme cart:refresh event below remains the fallback. */});
    }

    form.addEventListener('submit',function(event){
      var submitter=event.submitter;
      if(submitter&&submitter!==mainButton&&!submitter.matches('[name="add"]'))return;

      event.preventDefault();
      if(busy||mainButton.disabled)return;

      busy=true;
      window.clearTimeout(resetTimer);
      setStatus('Adding');

      var addUrl=jsonRoute(window.routes&&window.routes.cartAddUrl,'/cart/add');
      var formData=new FormData(form);

      fetch(addUrl,{
        method:'POST',
        body:formData,
        credentials:'same-origin',
        headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}
      })
        .then(function(response){
          return response.json().catch(function(){return {};}).then(function(payload){
            if(!response.ok)throw new Error(payload.description||payload.message||'Could not add item');
            return payload;
          });
        })
        .then(function(){
          finishWith('Added ✓',1400);

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{
            bubbles:true,
            detail:{scrollToTop:false}
          }));

          updateCartCount();
        })
        .catch(function(error){
          console.warn('[DP PDP ATC]',error);
          finishWith('Try again',1800);
        });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initDpPdpAtc,{once:true});
  }else{
    initDpPdpAtc();
  }
})();
